import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { CheckCircleFill, ExclamationCircleFill } from "react-bootstrap-icons";
import { useApp } from "../../../contexts/AppContext";

const UploadedFileItem = ({ file, onViewClick, onHelpClick }) => {
  const {
    device: { isMobile },
  } = useApp();

  const getStatusIcon = () => {
    if (file.status === "PENDING" || file.status === "STARTED") {
      return (
        <Spinner
          animation="border"
          size="sm"
          className="text-primary me-3 flex-shrink-0"
          style={{ width: "24px", height: "24px" }}
        />
      );
    } else if (file.status === "SUCCESS") {
      return <CheckCircleFill size={24} className="text-primary me-3" />;
    } else {
      return <ExclamationCircleFill size={24} className="text-danger me-3" />;
    }
  };

  const getStatusMessage = () => {
    if (file.status === "PENDING" || file.status === "STARTED") {
      return (
        <div className="status-message text-muted small">Processing...</div>
      );
    } else if (file.status === "SUCCESS") {
      console.log("file", file);
      return (
        <div className="status-message text-muted small">
          {`Successfully created, ${file.narratives_from_microservice || 0} narratives added, ${file.narratives_duplicates_skipped || 0} similar narratives merged.`}
        </div>
      );
    } else if (file.status === "FAILURE") {
      return (
        <div className="status-message text-danger small">
          {file.error === "Processing timeout"
            ? "Unable to create template. Please check file content."
            : file.error || "Invalid file format. Please import a .xls file."}
        </div>
      );
    }
    return null;
  };

  const getActionButton = () => {
    if (file.status === "SUCCESS") {
      return (
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => onViewClick(file.templateId)}
          className="font-weight-bold"
        >
          View
        </Button>
      );
    } else if (file.status === "FAILURE") {
      return (
        <Button
          variant="outline-danger"
          size="sm"
          onClick={onHelpClick}
          className="font-weight-bold"
        >
          Help
        </Button>
      );
    }
    return null;
  };

  return (
    <div className="uploaded-file-item mb-3">
      <div
        className={`file-content ${
          isMobile ? "mobile-layout" : "desktop-layout"
        }`}
      >
        <div className="file-info-section">
          <div className="d-flex align-items-center">
            {getStatusIcon()}
            <div>
              <div className="file-name fw-bold">
                {file.name}
                <span className="file-size text-muted fw-normal small ms-2">
                  {Math.round(file.size / 1024)}KB
                </span>
              </div>
              {getStatusMessage()}
            </div>
          </div>
          {!isMobile && <div className="file-actions">{getActionButton()}</div>}
        </div>
        {isMobile && (
          <div className="file-actions mobile-actions">{getActionButton()}</div>
        )}
      </div>
    </div>
  );
};

export default UploadedFileItem;
